import $ from 'jquery';
import './jquery.sidebar.min.js';

const mobileWindowWidth = 900;

$(function () {
    initializeSidebar();
});

function isClickOutsideSidebar(clicked) {
    return clicked.closest('#sidebar, #nav-open').length === 0;
}

function initializeSidebar() {
    const body = $('body');
    const sidebar = $('.sidebar');
    const darkCover = $('.darkCover');
    const sidebarWrap = $('.sidebar-wrap');
    const contentWrap = $('#content-wrap');

    if (sidebar.length === 0) {
        return false;
    }

    setEvents(body, darkCover, sidebar, sidebarWrap, contentWrap);

    contentWrap.addClass('opened-sidebar');

    sidebar.sidebar();

    darkCover.addClass('hideBackground');

    sidebar.removeClass('hidden');

    if ($(window).width() < mobileWindowWidth) {
        sidebar.trigger('sidebar:close', [{speed: 0}]);

        checkSidebarClasses(body, darkCover, sidebarWrap, false);
    } else {
        sidebar.trigger('sidebar:open', [{speed: 0}]);
    }
}

function checkSidebarClasses(body, darkCover, sidebarWrap, isOpen) {
    if (window.innerWidth < mobileWindowWidth && isOpen) {
        body.addClass('help-system__sidebar-opened');
        darkCover.removeClass('hideBackground');
        sidebarWrap.addClass('shadowEffect');
    } else if (window.innerWidth >= mobileWindowWidth && isOpen) {
        body.removeClass('help-system__sidebar-opened');
        sidebarWrap.removeClass('shadowEffect');
        darkCover.addClass('hideBackground');
    } else {
        body.removeClass('help-system__sidebar-opened');
        sidebarWrap.removeClass('shadowEffect');
        darkCover.addClass('hideBackground');
    }
}

function setEvents(body, darkCover, sidebar, sidebarWrap, contentWrap) {
    const navOpener = $('#nav-open');

    $('html').on('click', function (e) {
        if ($(window).width() < mobileWindowWidth && isClickOutsideSidebar($(e.target))) {
            $('.sidebar').trigger('sidebar:close');
        }
    });

    $('html').on('click', function (e) {
        if ($(e.target).closest('.sidebar').length === 0) {
            if ($(window).width() < mobileWindowWidth && $('.opened-sidebar').length !== 0) {
                sidebar.trigger('sidebar:close');
                checkSidebarClasses(body, darkCover, sidebarWrap, false);
            }
        }
    });

    $(window).on('resize', function () {
        const isSidebarClosed = $('.opened-sidebar').length === 0;

        if (window.innerWidth > mobileWindowWidth && isSidebarClosed) {
            sidebar.trigger('sidebar:open', [{speed: 0}]);
        } else if (window.innerWidth < mobileWindowWidth && !isSidebarClosed) {
            sidebar.trigger('sidebar:close');
        }

        checkSidebarClasses(body, darkCover, sidebarWrap, false);
    });

    navOpener.click(function () {
        sidebar.trigger('sidebar:toggle');
    });

    sidebar.on('sidebar:opened', function () {
        window.scrollTo({top: 0});

        navOpener.addClass('active');
        contentWrap.addClass('opened-sidebar');
        checkSidebarClasses(body, darkCover, sidebarWrap, true);
    });

    sidebar.on('sidebar:closed', function () {
        navOpener.removeClass('active');
        contentWrap.removeClass('opened-sidebar');
        checkSidebarClasses(body, darkCover, sidebarWrap, false);
    });
}
